<template>
  <div>
    <b-modal
      id="disclaimerModalDE"
      ref="disclaimerModalDE"
      title
      style="text-align:left"
      size="lg"
      :hide-footer="true"
    >
      <h3>Datenschutzerklärung für das &frankly Umfragetool</h3>
      <p class="disclaimer">
        Durch den kulturellen Wandel und die weiteren Veränderungen im Unternehmen ist es für uns noch wichtiger Feedback von Dir zur generellen Stimmung im Unternehmen zu erhalten und Dich noch enger an der Gestaltung und der Entwicklung von ESPRIT und unseren Prozessen zu beteiligen. Hierfür möchten wir &frankly einsetzen, ein Softwaretool, das es Dir ermöglicht uns anonym und vertraulich Feedback zu geben. Wie das funktioniert und wie Deine Daten verarbeitet werden, erklären wir Euch hier.
        Uns ist der Schutz Deiner personenbezogenen Daten und die Vertraulichkeit und Anonymität Deiner Antworten auf unsere Umfrage wichtig. Solltest Du Fragen zum Umgang mit Deinen Daten haben, kannst Du uns jederzeit ansprechen. Wende Dich am einfachsten an dataprotection@esprit.com.
      </p>
      <h4>MUSS ICH &FRANKLY NUTZEN UND WIE FUNKTIONIERT DAS ÜBERHAUPT?</h4>
      <p class="disclaimer">
        Du musst &frankly nicht nutzen. Das &frankly Tool ist ein Angebot von uns an Dich, damit Du schneller, einfacher und vor allem anonym Dein Feedback zu verschiedenen Fragen an uns übermitteln kannst, wenn Du es möchtest. Du kannst auch weiterhin auf jedem anderen Weg mit uns in Kontakt treten, um uns Rückmeldung, Hinweise und Anregungen zu geben.
        Das &frankly Tool ist eine Softwarelösung, die technisch von der schwedischen Andfrankly Pulse AB betrieben wird. Die Lösung besteht aus einer App und einer Antwortsoftware. Die &frankly App wird auf den Smartphones und Endgeräten der Umfrageteilnehmer installiert. Über die App werden die Umfragen, welche wir erstellen, an Dich übermittelt. Die gegebenen Antworten werden an die Antwortsoftware übermittelt, die auf Systemen liegt, die ausschließlich von der Andfrankly Pulse AB betrieben werden. ESPRIT hat hierauf keinen Zugriff. In der Antwortsoftware werden die Antworten der Umfrageteilnehmer gesammelt und grafisch aufbereitet, um zu zeigen, wie die Nutzer der App zu den gestellten Fragen geantwortet haben. Die Aufbereitung der Antworten bezieht sich immer auf Personenmehrheiten. Wir haben zu keiner Zeit die Möglichkeit zu erfahren, ob und wie Du oder ein anderer einzelner Mitarbeiter abgestimmt hat. Wir können und wollen die abgegebenen Antworten auch nicht nutzen, um automatisch, also computergestützt, Entscheidungen zu treffen oder ein sog. Profiling durchzuführen.
        Weil wir, als ESPRIT, niemals erfahren, wer wie abgestimmt hat, unsere Umfragen aber ausschließlich firmeninterne Angelegenheiten betreffen, ist es wichtig, dass auch nur Mitarbeiter von ESPRIT Zugang zum &frankly Tool erhalten. Um dies sicherzustellen bitten wir Dich um die Angabe Deiner privaten E-Mailadresse.
        Deine private Mailadresse, die Du im Rahmen des Onboardings zur digitalen Gehaltsabrechnung bei unserem Dienstleister MiSoft angeben kannst, wird genutzt um Deinen persönlichen Zugang zum &frankly Tool zu erstellen. Durch den Nutzerzugang über Deine privaten Kontaktdaten wird auch sichergestellt, dass keiner Deiner Kollegen, die mitunter Leserechte für Deine Firmen-E-Mailadresse haben, Zugriff auf Deine Antworten im &frankly Tool erhält. Deine Mailsdresse wird direkt von MiSoft an die Andfrankly Pulse AB weitergeleitet, wir erhalten sie nicht. Ebenfalls werden wir auch nie erfahren, ob Du an den Umfragen über das &frankly Tool teilnimmst.
      </p>
      <h4>WAS MUSS ICH DATENSCHUTZRECHTLICH NOCH ZU &FRANKLY WISSEN?</h4>
      <p class="disclaimer">
        „Wir“, die ESPRIT Europe GmbH, sind datenschutzrechtlich für die Verarbeitung Deiner Daten verantwortlich. Wir haben die Andfrankly Pulse AB, Regeringsgatan 52, 111 56 Stockholm, Schweden damit beauftragt für uns Umfragen mit dem &Frankly Tool technisch durchzuführen. Damit Dir ein Nutzerzugang zum &frankly Tool eingerichtet werden kann, haben wir die MiSoft Gesellschaft für Softwareentwicklung und elektronische Dienstleistungen GmbH, Heilsbachstr. 30, 53123 Bonn, mit dem Erhebung der nötigen Mailadressen beauftragt. Du kannst bei Fragen und Anliegen zum Datenschutz nicht nur Kontakt mit uns, sondern unter datenschutz@esprit.de auch mit unserem Datenschutzbeauftragten, aufnehmen.
        Zweck der Durchführung der Umfragen ist die Erhebung eines Stimmungsbildes unserer Mitarbeiter vor dem Hintergrund der aktuellen Entwicklung und des Wandels in unserem Unternehmen, sowie die engere Beteiligung der Mitarbeiter am Unternehmen. Die Einrichtung und Nutzung des &frankly Tools bei Dir ist freiwillig und erfolgt nur auf Grundlage Deiner ausdrücklichen Einwilligung (Art. 6 Abs. I Buchstabe a DS-GVO). Diese Einwilligung kannst Du jederzeit frei widerrufen, indem Du uns einen kurzen Hinweis gibst. Bitte beachte, dass die Rechtmäßigkeit unserer bisherigen Verarbeitung Deiner Daten auf Grund Deiner Einwilligung bis zum Widerruf dadurch nicht entfällt. Sofern Du Deine Einwilligung nicht vorher widerrufst, werden wir mit Deinem Ausscheiden bei ESPRIT Deine personenbezogenen Daten aus dem &frankly Tool löschen lassen.
        Bei Vorliegen der gesetzlichen Voraussetzungen hast Du das Recht auf Auskunft (Art. 15 DS-GVO), Berichtigung (Art. 16 DS-GVO), Löschung (Art. 17 DS-GVO) oder Einschränkung (Art. 18 DS-GVO) der Verarbeitung, auf Datenübertragbarkeit (Art. 20 DS-GVO) und auf Widerspruch gegen die Datenverarbeitung (Art. 21 DS-GVO). Außerdem hast Du das Recht zur Beschwerde bei der für Dich zuständigen Datenschutzbehörde.
      </p>
    </b-modal>
    <b-modal
      id="disclaimerModalEN"
      ref="disclaimerModalEN"
      title
      style="text-align:left"
      size="lg"
      :hide-footer="true"
    >
      <h3>Privacy policy for the &frankly survey tool</h3>
      <p class="disclaimer">
        As a result of cultural change and other changes within the company, it is even more important for us to receive feedback from you on the general mood within the company and to involve you even more closely in the design and development of ESPRIT and our processes. For this purpose we would like to use &frankly, a software tool that allows you to give us anonymous and confidential feedback. How this works and how your data is processed, we explain to you here.
        The protection of your personal data and the confidentiality and anonymity of your answers to our survey are important to us. If you have any questions regarding the handling of your data, you can contact us at any time. The easiest way is to contact dataprotection@esprit.com.
      </p>
      <h4>DO I HAVE TO USE &FRANKLY AND HOW DOES IT WORK?</h4>
      <p class="disclaimer">
        You don't have to use &frankly. The &frankly tool is an offer from us to you, so that you can quickly, easily and, above all anonymously, provide your feedback on different questions to us. You can continue to contact us in any other way to give us feedback, tips and suggestions.
        The &frankly Tool is a software solution which is technically operated by the Swedish Andfrankly Pulse AB. The solution consists of an app and a response software. The &frankly app is installed on the smartphones and terminals of the survey participants. The surveys that we create are transmitted to you via the app. The answers given are sent to the answering software, which is installed on systems operated exclusively by Andfrankly Pulse AB. ESPRIT does not have access to them. The answers of the survey participants are collected in the response software and graphically processed to show how the users of the app answered the questions asked. The processing of the answers always refers to majorities of persons. At no time do we have the opportunity to find out whether and how you or any other individual employee voted. We cannot and do not want to use the answers given to make decisions automatically, i.e. computer-aided, or to carry out so-called profiling. It is therefore ensured that your personal answers can only be evaluated in anonymous form through your personal access.
        Because we, as ESPRIT, never know who voted how, but our surveys only concern internal company matters, it is important that only ESPRIT employees have access to the &frankly tool. To ensure this, we ask you to provide your private email address.
        Your private email address, which you can provide when onboarding for digital payroll at our service provider MiSoft, will be used to create your personal access to the &frankly tool.
        Once we have received your email address, we will forward it to Andfrankly Pulse AB to create your personal account. We will only use your private email address to provide you with access to the &frankly tool.
      </p>
      <h4>WHAT ELSE DO I NEED TO KNOW ABOUT &FRANKLY?</h4>
      <p class="disclaimer">
        "We", ESPRIT Europe GmbH, are responsible for the processing of your data under data protection law. We have commissioned Andfrankly Pulse AB, Regeringsgatan 52, 111 56 Stockholm, Sweden to conduct technical surveys for us using the &Frankly tool. In order to provide you with user access to the &Frankly Tool, we have commissioned MiSoft Gesellschaft für Softwareentwicklung und elektronische Dienstleistungen GmbH, Heilsbachstr. 30, 53123 Bonn, Germany, to collect the necessary e-mail addresses. If you have any questions or concerns regarding data protection, you can not only contact us, but also our data protection officer at datenschutz@esprit.de.
        The purpose of carrying out the surveys is to survey the mood of our employees against the background of current developments and changes in our company, as well as the closer participation of employees in the company. The installation and use of the &frankly tool is voluntary and only takes place on the basis of your explicit consent (Art. 6 para. I letter a GDPR). You can freely revoke this consent at any time by giving us a short note. Please note that the legality of our previous processing of your data on the basis of your consent until revocation does not thereby cease. Unless you revoke your consent beforehand, we will have your personal data deleted from the &frankly tool when you leave ESPRIT.
        If the legal requirements are met, you have the right to information (art. 15 GDPR), correction (art. 16 GDPR), deletion (art. 17 GDPR) or restriction (art. 18 GDPR) of the processing, to data transferability (art. 20 GDPR) and to object to data processing (art. 21 GDPR). You also have the right to lodge a complaint with the data protection authority responsible for you.
      </p>
    </b-modal>
    <b-modal
      id="disclaimerModalFR"
      ref="disclaimerModalFR"
      title
      style="text-align:left"
      size="lg"
      :hide-footer="true"
    >
      <h3>Déclaration de confidentialité sur la protection de données pour l'outil de sondage &frankly</h3>
      <p class="disclaimer">
        En raison du changement culturel et d'autres changements au sein de l'entreprise, il est encore plus important pour nous de recevoir tes commentaires sur l'ambiance générale au sein de l'entreprise et de t’intéger encore plus prochement dans la conception et le développement d'ESPRIT et de nos processus. Pour cela, nous aimerions utiliser &frankly, un outil logiciel qui te permet de nous donner un feedback anonyme et confidentiel. Nous t’expliquons ci-dessous comment cela fonctionne et comment tes données sont traitées.
        La protection de tes données personnelles ainsi que la confidentialité et l'anonymat de tes réponses à notre enquête sont importants pour nous. Si tu as des questions concernant le traitement de tes données, tu peux nous contacter à tout moment. La façon la plus simple est de contacter dataprotection@esprit.com.
      </p>
      <h4>DOIS-JE UTILISER &FRANKLY ET COMMENT ÇA MARCHE ?</h4>
      <p class="disclaimer">
        Tu n’as pas besoin d'utiliser &frankly. L'outil &frankly est une offre de notre part, afin que tu puisses nous transmettre plus rapidement, plus facilement et surtout de manière anonyme tes commentaires à différentes questions si tu le souhaites. Tu peux continuer à nous contacter par tout autre moyen pour nous faire part de tes commentaires, conseils et suggestions.
        L’outil &frankly est une solution logicielle gérée techniquement par le suédois Andfrankly Pulse AB. La solution se compose d'une application et d'un logiciel de réponse. L'application &frankly est installée sur les smartphones et terminaux des participants à l'enquête. Les enquêtes que nous créons te sont transmises via l'application. Les réponses données sont envoyées au logiciel de réponse, qui est installé sur les systèmes exploités exclusivement par Andfrankly Pulse AB. ESPRIT n'y a pas accès. Les réponses des participants à l'enquête sont collectées dans le logiciel de réponse et traitées graphiquement pour montrer comment les utilisateurs de l'application ont répondu aux questions posées. Le traitement des réponses se réfère toujours à des majorités de personnes. Nous n'avons à aucun moment l'occasion de savoir si et comment tu ou un autre employé a voté. Nous ne pouvons et ne voulons pas utiliser les réponses données pour prendre des décisions automatiquement, c'est-à-dire assisté par ordinateur, ou pour effectuer ce qu'on appelle le « profilage ». Il est donc assuré que tes réponses personnelles ne seront exploitées qu’en forme anonyme. Parce que nous, en tant qu'ESPRIT, ne savons jamais qui a voté comment, mais nos enquêtes ne concernent que les questions internes à l'entreprise, il est important que seuls les employés d'ESPRIT aient accès à l'outil &frankly.
        Pour ce faire, nous te demandons de fournir ton adresse électronique privée. Ton adresse e-mail privée, que tu peux fournir lors de l'intégration de la paie numérique chez notre prestataire de services MiSoft, sera utilisée pour créer ton accès personnel à l'outil &frankly.
        L'accès des utilisateurs via tes données de contact privées garantit également qu'aucun de tes collègues, qui ont parfois des droits de lecture sur ton adresse e-mail professionnelle, n'aura accès à tes réponses dans l'outil &frankly.
        Ton adresse e-mail sera transférée directement de MiSoft à Andfrankly Pulse AB, nous ne la recevrons pas. De plus, nous ne saurons jamais si tu participes à des enquêtes en utilisant l'outil &frankly.
      </p>
      <h4>QUE DOIS-JE SAVOIR D'AUTRE SUR &FRANKLY ?</h4>
      <p class="disclaimer">
        "Nous", ESPRIT Europe GmbH, sommes responsables du traitement de tes données conformément à la loi sur la protection des données. Nous avons chargé Andfrankly Pulse AB, Regeringsgatan 52, 111 56 Stockholm, Suède, de réaliser pour nous des études techniques en utilisant l'outil &Frankly. Afin de te donner accès à l'outil &Frankly, nous avons chargé MiSoft Gesellschaft für Softwareentwicklung und elektronische Dienstleistungen GmbH, Heilsbachstr. 30, 53123 Bonn, Allemagne, de rassembler les adresses e-mail nécessaires. Si tu as des questions ou des préoccupations concernant la protection des données, tu peux non seulement nous contacter, mais également notre responsable de la protection des données à datenschutz@esprit.de.
        L'objectif de ces enquêtes est de sonder l'état d'esprit de nos collaborateurs dans le contexte de l'évolution et des changements actuels de notre entreprise, ainsi que d'une participation plus étroite des collaborateurs au sein de l'entreprise. L'installation et l'utilisation de l'outil &frankly est volontaire et n'a lieu que sur la base de ton consentement explicite (art. 6 al. 1 lettre a RGPD. Tu peux à tout moment révoquer librement ce consentement en nous adressant un bref message. Nous te prions de prendre note que la légalité de notre traitement précédent de tes données sur la base de votre consentement jusqu'à ce que la révocation ne cesse pas de ce fait. A moins que tu ne révoques ton consentement au préalable, tes données personnelles seront supprimées de l'outil &frankly lorsque tu quitteras ESPRIT.
        Si les conditions légales sont remplies, tu disposes d'un droit d'information (art. 15 RGPD), de rectification (art. 16 RGPD), de suppression (art. 17 RGPD), de restriction du traitement (art. 18 RGPD), de portabilité des données (art. 20 RGPD) et du droit de demander la suppression de tes données personnelles. Tu as également le droit de porter plainte auprès de l'autorité de protection des données qui est responsable pour toi.
      </p>
    </b-modal>
    <b-modal
      id="disclaimerModalIT"
      ref="disclaimerModalIT"
      title
      style="text-align:left"
      size="lg"
      :hide-footer="true"
    >
      <h3>Informativa sulla privacy per lo strumento di indagine &frankly</h3>
      <p class="disclaimer">
        Come risultato del cambiamento culturale e di altri cambiamenti all'interno dell'azienda ESPRIT, è ancora più importante per noi ricevere da voi un feedback sul vostro stato d'animo generale all'interno dell'azienda e cosi poter coinvolgervi ancora di più nella progettazione, nello sviluppo e nei processi dell’azienda. A questo scopo vorremmo utilizzare &frankly (uno strumento software che permette di darci un feedback anonimo e riservato).
        La sua funzionalità e il trattamento dei vostri dati, verranno spiegate in seguito. La protezione dei vostri dati personali, la riservatezza e l'anonimato delle vostre risposte al nostro sondaggio è importante per noi. Domande riguardo al trattamento dei vostri dati possono essere rivolte in qualsiasi momento contattando semplicemente dataprotection@esprit.com.
      </p>
      <h4>DEVO USARE &FRANKLY E COME FUNZIONA?</h4>
      <p class="disclaimer">
        L’uso di &frankly è una tua scelta. &frankly è uno strumento che vi proponiamo affinché possiate trasmettere il vostro feedback a diverse domande poste a noi in modo più veloce, più facile e soprattutto anonimo sempre se lo desiderate. Puoi anche continuare a contattarci in qualsiasi altro modo per darci un feedback, delle indicazioni o dei suggerimenti.
        Lo strumento &frankly è una soluzione software gestita tecnicamente dal svedese Andfrankly Pulse AB. La soluzione consiste in un'applicazione e una software di risposta. L'applicazione &frankly viene installata sugli smartphone e sui terminali mobili dei partecipanti al sondaggio. I sondaggi creati vengono trasmessi all'utente tramite l'applicazione. Le risposte fornite vengono inviate alla software di risposta, installata sui sistemi gestiti esclusivamente da Andfrankly Pulse AB. ESPRIT non ha nessun accesso ad essi.
        Le risposte fornite dai partecipanti al sondaggio vengono raccolte nella software di risposta ed elaborate graficamente per mostrare come gli utenti dell'applicazione hanno risposto alle domande poste. L'elaborazione delle risposte si riferisce sempre a maggioranze di persone. In nessun momento abbiamo la possibilità di verificare se avete e come avete votato voi o qualsiasi altro singolo dipendente. Non possiamo e non vogliamo utilizzare le risposte fornite per automaticizzare decisioni, cioè con l'aiuto di computerò per effettuare dei cosiddetti "profiling". Quindi ti è assicurato, che l’elaborazione delle risposte date attraverso il tuo accesso personale vengono prelevate solo in forma anonima
        Poiché noi, come ESPRIT, non sappiamo mai chi ha votato come, è importante che solo dipendenti dell’azienda ESPRIT abbiano accesso allo strumento &frankly dato che le nostre indagini riguardano solo questioni interne dell'azienda. Al fin di poterci assicurare, ti chiediamo di fornire il tuo indirizzo e-mail privato, che potrai mettere a disposizione al momento dell'iscrizione al libro paga digitale presso il nostro fornitore di servizi MiSoft, che verrà utilizzato per creare il tuo accesso personale allo strumento &frankly.
        Appena riceveto il tuo indirizzo e-mail, invieremo questo alla Andfrankly Pulse AB per la creazione del tuo accesso personale. Il tuo indirizzo e-mail sarà usato esclusivamente per metterti a disposizione l’accesso allo strumento &frankly.
      </p>
      <h4>COS'ALTRO DEVO SAPERE SU &FRANKLY?</h4>
      <p class="disclaimer">
        "ESPRIT Europe GmbH è responsabile del trattamento dei vostri dati secondo la legge sulla protezione dei dati personali. Abbiamo commissionato ad Andfrankly Pulse AB, Regeringsgatan 52, 111 56 Stoccolma, Svezia, l'esecuzione di indagini tecniche per noi utilizzando lo strumento &Frankly. Al fine di fornire all'utente l'accesso allo strumento &Frankly, abbiamo incaricato la MiSoft Gesellschaft für Softwareentwicklung und elektronische Dienstleistungen GmbH, Heilsbachstr. 30, 53123 Bonn, Germania, di raccogliere gli indirizzi e-mail necessari. Se avete domande o dubbi sulla protezione dei dati, potete contattare noi oppure il nostro responsabile alla protezione dei dati inviando una e-mail a questo indirizzo datenschutz@esprit.de
        Lo scopo dell'indagine è quello di analizzare lo stato d'animo dei nostri dipendenti sulla base degli sviluppi e dei cambiamenti in atto nella nostra azienda, nonché la stretta partecipazione dei dipendenti all'azienda. L'installazione e l'utilizzo dello strumento &frankly è volontario e avviene solo con il vostro esplicito consenso (art. 6 cpv. I lettera a DS-GVO). È possibile revocare liberamente questo consenso in qualsiasi momento dandoci una breve nota. Si prega di notare che la legalità del nostro precedente trattamento dei vostri dati sulla base del vostro consenso fino alla revoca non cessa.
        A meno che tu non revochi il tuo consenso in anticipo, i tuoi dati personali saranno cancellati dallo strumento &frankly quando lasci ESPRIT. Se sono soddisfatti i requisiti legali, avrai il diritto all'informazione (art. 15 ODerr), alla rettifica (art. 16 ODerr), alla cancellazione (art. 17 ODerr) o alla limitazione (art. 18 ODerr) dell'elaborazione, alla trasferibilità dei dati (art. 20 ODerr) e all'opposizione all'elaborazione dei dati (art. 21 ODerr). Avete anche il diritto di presentare un reclamo all'autorità responsabile per la protezione dei dati personali.
      </p>
    </b-modal>
    <div v-if="viewForm">
      <h1
        v-bind:style="{ color: Company.CI_Headlinecolor }"
        class="mb-4"
        align="center"
      >{{LanguageStrings[DisplayLanguage]['esprit_headline_register']}}</h1>
      <h2
        v-bind:style="{ color: Company.CI_Headlinecolor }"
        class="mb-4"
        style="font-style: italic"
      >{{LanguageStrings[DisplayLanguage]['esprit_sicherheitsmerkmale']}}</h2>
      <p class="textcolor" v-if="this.Company.RegisterMode != 0">
        <input
          type="checkbox"
          id="email"
          onclick="return false;"
          :checked="new RegExp(/^[a-zA-Z0-9\.\-_]+@[a-zA-Z0-9\.\-_]+\.[a-zA-Z0-9\.]{2,}$/).exec((email+'').trim()) != null"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_email']}}
      </p>
      <p class="textcolor" v-if="this.Company.RegisterMode != 0">
        <input
          type="checkbox"
          id="email2"
          onclick="return false;"
          :checked="(email+'').length > 0 && (email + '').trim() == (email2 + '').trim()"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_emailmatch']}}
      </p>
      <p class="textcolor">
        <input
          type="checkbox"
          id="uppercase"
          onclick="return false;"
          :checked="new RegExp('[A-Z]').exec(password+'')"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_uppercase']}}
      </p>
      <p class="textcolor">
        <input
          type="checkbox"
          id="lowercase"
          onclick="return false;"
          :checked="new RegExp('[a-z]').exec(password+'')"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_lowercase']}}
      </p>
      <p class="textcolor">
        <input
          type="checkbox"
          id="number"
          onclick="return false;"
          :checked="new RegExp('[0-9]').exec(password+'')"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_number']}}
      </p>
      <p class="textcolor">
        <input
          type="checkbox"
          id="minlen"
          onclick="return false;"
          :checked="(password+'').trim().length >= 8"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_length']}}
      </p>
      <p class="textcolor">
        <input
          type="checkbox"
          id="pwequal"
          onclick="return false;"
          :checked="(password+'').trim().length > 0 && password+'' == password2+''"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_pwmatch']}}
      </p>
      <p class="textcolor" v-if="this.GS.CredentialMode">
        <input
          type="checkbox"
          id="credential1check"
          onclick="return false;"
          :checked="(credential1+'').trim().length > 0"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['esprit_register_credential1_check']}}
      </p>
      <p class="textcolor" v-if="this.GS.CredentialMode">
        <input
          type="checkbox"
          id="credential2check"
          onclick="return false;"
          :checked="(credential2+'').trim().length > 0"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['esprit_register_credential2_check']}}
      </p>
      <form id="registerform" onsubmit="return false;" class="mt-4" autocomplete="off">
        <div class="form-group" v-show="Company.RegisterMode != 0">
          <label
            for="form_email"
            v-bind:style="{ color: Company.CI_Textcolor }"
          >{{LanguageStrings[DisplayLanguage]['register_esprit_username']}}</label>
          <input type="text" autocomplete="off" class="form-control" name="form_email" v-model="email" />
        </div>
        <div class="form-group" v-show="Company.RegisterMode != 0">
          <label
            for="form_email2"
            v-bind:style="{ color: Company.CI_Textcolor }"
          >{{LanguageStrings[DisplayLanguage]['username2']}}</label>
          <input
            type="text"
            onpaste="return false"
            class="form-control"
            autocomplete="off"
            name="form_email2"
            v-model="email2"
          />
        </div>
        <div class="form-group" v-show="Company.RegisterMode != 0 && !this.GS.CredentialMode">
          <label
            for="form_tan"
            v-bind:style="{ color: Company.CI_Textcolor }"
            translate="no"
          ><span>T</span><span>A</span><span>N</span></label>
                    <input type="text" class="form-control" name="form_tan" v-model="GS.Tan" v-if="!this.GS.CredentialMode" />
          <input type="text" class="form-control" name="form_senderid" v-model="Company.SenderId" v-if="this.GS.CredentialMode" />
        </div>
        <div class="form-group">
          <label
            for="form_password"
            v-bind:style="{ color: Company.CI_Textcolor }"
          >{{LanguageStrings[DisplayLanguage]['password']}}</label>
          <input
            type="password"
            autocomplete="new-password"
            class="form-control"
            name="form_password"
            v-model="password"
          />
        </div>
        <div class="form-group">
          <label
            for="form_password2"
            v-bind:style="{ color: Company.CI_Textcolor }"
          >{{LanguageStrings[DisplayLanguage]['password2']}}</label>
          <input
            type="password"
            autocomplete="new-password"
            class="form-control"
            name="form_password2"
            v-model="password2"
            v-on:keyup.enter="register()"
          />
        </div>
        <div class="form-group" v-if="this.GS.CredentialMode">
          <label
            for="form_credential1"
            v-bind:style="{ color: Company.CI_Textcolor }"
          >{{LanguageStrings[DisplayLanguage]['esprit_register_credential1']}}</label>
          <input
            type="text"
            class="form-control"
            autocomplete="none"
            name="form_credential1"
            v-on:keypress='validateNumbers($event)'
            maxlength="8"
            v-model="credential1"
          />
        </div>
        <div class="form-group" v-if="this.GS.CredentialMode">
          <label
            for="form_credential2"
            v-bind:style="{ color: Company.CI_Textcolor }"
          >{{LanguageStrings[DisplayLanguage]['esprit_register_credential2']}}</label>
          <input
            type="text"
            class="form-control"
            autocomplete="none"
            name="form_credential2"
            maxlength="3"
            v-model="credential2"
            v-on:keypress='validateNumbers($event)'
            v-on:keyup.enter="registerByCredential()"
          />
        </div>
        <p class="text-muted" style="margin-bottom:15px; margin-top: 15px; font-style: italic">
          <span v-if="DisplayLanguage == 'de'">
            Durch Klicken auf den „Registrieren“-Button übersendest Du Deine oben angegebenen Daten an uns zum Zweck der Teilnahme an der digitalen Gehaltsabrechnung. Hierfür gelten unsere 
            <a
              href="../Payslip_Datenschutzerklaerung.pdf"
              target="_blank"
            >Datenschutzinformationen für die digitale Gehaltsabrechnung</a>.
          </span>
          <span v-if="DisplayLanguage == 'en'">
            By clicking on the "Sign up" button, you send the above data to us for the purpose of participating in the digital payslip. This is subject to our 
            <a
              href="../Payslip_PrivacyPolicy.pdf"
              target="_blank"
            >information on data privacy for the digital payslip</a>.
          </span>
          <span v-if="DisplayLanguage == 'fr'">
            En cliquant sur le bouton "S'inscrire", tu nous envoies les données ci-dessus afin de participer à la paie numérique. Ceci est soumis à notre
            <a
              href="../Payslip_PrivacyPolicy.pdf"
              target="_blank"
            >déclaration de protection de données</a>.
          </span>
          <span v-if="DisplayLanguage == 'it'">
            Cliccando sul pulsante "Registro", ci invii i dati di cui sopra per partecipare alla busta paga digitale. Questo è soggetto alla nostra
            <a
              href="../Payslip_PrivacyPolicy.pdf"
              target="_blank"
            >consenso al trattamento dei dati personali</a>.
          </span>
          <span
            v-if="DisplayLanguage == 'pt' || DisplayLanguage == 'es' || DisplayLanguage == 'pl' || DisplayLanguage == 'nl'"
          >
            By clicking on the "Sign up" button, you send the above data to us for the purpose of participating in the digital payslip. This is subject to our 
            <a
              href="../Payslip_PrivacyPolicy.pdf"
              target="_blank"
            >information on data privacy for the digital payslip</a>.
          </span>
        </p>
        <!--<p class="textcolor" style="margin-bottom:15px" v-if="GS.Checkbox1Prefill == undefined">
          <input type="checkbox" id="checkbox1" name="form_checkbox1" v-model="checkbox1" />
          &nbsp;
          <span v-if="DisplayLanguage == 'de'">
            Ich bin damit einverstanden über diese Mailadresse zu dem Mitarbeiterumfragetoool (&frankly) registriert zu werden und Informationen zu erhalten. Die Anmeldung zu &frankly ist freiwillig und beeinflusst nicht die Teilnahme an der digitalen Gehaltsabrechnung. Für &frankly gelten unsere
            <a
              href="#"
              @click="$refs.disclaimerModalDE.show();"
            >Datenschutzinformationen für &frankly</a>.
          </span>
          <span v-if="DisplayLanguage == 'en'">
            I agree to be registered for the employee survey tool (&frankly) via this e-mail address and to receive information. The registration to &frankly is voluntary and does not influence the participation in the digital payslip. For &frankly, our 
            <a
              href="#"
              @click="$refs.disclaimerModalEN.show();"
            >information on data privacy for &frankly</a> applies.
          </span>
          <span v-if="DisplayLanguage == 'fr'">
            Je confirme que j’accepte d’être informé via cette adresse de courriel / e-mail de l’application de sondage des employés (&frankly). Je confirme avoir reçu l’information des employés concernant la
            <a
              href="#"
              @click="$refs.disclaimerModalFR.show();"
            >protection des données</a>.
          </span>
          <span v-if="DisplayLanguage == 'it'">
            Le confermo di potermi informare su questo indirizzo email riguardo lo strumento di indagine dei dipendenti (&frankly). Inoltre le confermo di aver preso nota
            <a
              href="#"
              @click="$refs.disclaimerModalIT.show();"
            >sull’informativa della privacy</a>.
          </span>
          <span
            v-if="DisplayLanguage == 'pt' || DisplayLanguage == 'es' || DisplayLanguage == 'pl' || DisplayLanguage == 'nl'"
          >
            I agree to be registered for the employee survey tool (&frankly) via this e-mail address and to receive information. The registration to &frankly is voluntary and does not influence the participation in the digital payslip. For &frankly, our 
            <a
              href="#"
              @click="$refs.disclaimerModalEN.show();"
            >information on data privacy for &frankly</a> applies.
          </span>
        </p>
        <input
          v-if="GS.Checkbox1Prefill != undefined"
          type="hidden"
          name="form_checkbox1"
          v-model="GS.Checkbox1Prefill"
        />-->
        <div>
          <input
            class="btn btn-success"
            type="button"
            :value="LanguageStrings[DisplayLanguage]['register']"
            :disabled="!canRegister"
            @click="register()"
            v-if="!this.GS.CredentialMode"
          />
          <input
            class="btn btn-success"
            type="button"
            :value="LanguageStrings[DisplayLanguage]['register']"
            :disabled="!canRegisterByCredential"
            @click="registerByCredential()"
            v-if="this.GS.CredentialMode"
          />
        </div>
        
        <input type="hidden" name="lang" :value="DisplayLanguage" />
      </form>
    </div>
    <div v-if="showOK">
      <h1
        v-bind:style="{ color: Company.CI_Headlinecolor }"
        class="mb-0"
        align="center"
      >{{LanguageStrings[DisplayLanguage]['register_ok_mail']}}</h1>
    </div>
    <div v-if="showOKNoMail">
      <h1
        v-bind:style="{ color: Company.CI_Headlinecolor }"
        class="mb-0"
        align="center"
      >{{LanguageStrings[DisplayLanguage]['register_ok']}}</h1>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "RegisterEsprit",
  components: {
    //HelloWorld
  },
  data: function() {
    return {
      viewForm: true,
      email: "",
      email2: "",
      password: "",
      password2: "",
      credential1: "",
      credential2: "",
      showOK: false,
      showOKNoMail: false,
      checkbox1: false
    };
  },
  mounted: function() {
    if (this.Session != null && this.Session.Company.RegisterMode == 0) {
      this.email = (this.Session.To + '').trim();
      this.email2 = (this.Session.To + '').trim();
    }
    if (this.GS.PrefilledMail != null) {
      this.email = (this.GS.PrefilledMail + '').trim();
      this.email2 = (this.GS.PrefilledMail + '').trim();
    }
  },
  computed: {
    canRegister: function() {
      /*if (!this.checkbox1) {
        return false;
      }*/
      if ((this.GS.Tan + "").trim().length != 12) {
        return false;
      }
      if (
        new RegExp(
          /^[a-zA-Z0-9\.\-_]+@[a-zA-Z0-9\.\-_]+\.[a-zA-Z0-9\.]{2,}$/
        ).exec((this.email + "").trim()) == null
      ) {
        return false;
      }
      if (new RegExp("[A-Z]").exec(this.password + "") == null) {
        return false;
      }
      if (new RegExp("[a-z]").exec(this.password + "") == null) {
        return false;
      }
      if (new RegExp("[0-9]").exec(this.password + "") == null) {
        return false;
      }
      if ((this.password + "").trim().length < 8) {
        return false;
      }
      if (
        (this.password + "").trim().length == 0 ||
        this.password + "" != this.password2 + ""
      ) {
        return false;
      }
      if (this.email.trim() != this.email2.trim()) {
        return false;
      }
      return true;
    },
    canRegisterByCredential: function()
    {
      if (
        new RegExp(
          /^[a-zA-Z0-9\.\-_]+@[a-zA-Z0-9\.\-_]+\.[a-zA-Z0-9\.]{2,}$/
        ).exec((this.email + "").trim()) == null
      ) {
        return false;
      }
      if (new RegExp("[A-Z]").exec(this.password + "") == null) {
        return false;
      }
      if (new RegExp("[a-z]").exec(this.password + "") == null) {
        return false;
      }
      if (new RegExp("[0-9]").exec(this.password + "") == null) {
        return false;
      }
      if ((this.password + "").trim().length < 8) {
        return false;
      }
      if ((this.credential1 + "").trim().length == 0) {
        return false;
      }
      if ((this.credential2 + "").trim().length == 0) {
        return false;
      }
      if (this.email.trim() != this.email2.trim()) {
        return false;
      }
      if (
        (this.password + "").trim().length == 0 ||
        this.password + "" != this.password2 + ""
      ) {
        return false;
      }
      return true;
    },
  },
  methods: {
    register: function() {
      if (!this.canRegister || this.GS.CredentialMode) {
        return;
      }
      this.$parent.errortext = null;
      var self = this;
      axios
        .post(
          this.GS.Endpoint + "/v2/register/",
          this.form2JSON(document.getElementById("registerform")),
          {}
        )
        .then(function(response) {
          if (self.Session != null && self.Company.RegisterMode == 0) {
            self.GS.Session = response.data;
            self.$router.push("/read");
          } else {
            self.viewForm = false;
            self.showOK = true;
          }
        })
        .catch(function(response) {
          window.scrollTo(0,0);
          //console.log(response);
          if (response.response == undefined) {
            self.$parent.errortext = "internalservererror";
            return;
          }
          if (response.response.status == 410) {
            self.$parent.errortext = "sessionexpired";
            return;
          }
          if (response.response.status == 403) {
            self.$parent.errortext = "loginblocked";
            return;
          }
          if (response.response.status == 401) {
            self.$parent.errortext = "loginfailed";
            return;
          }
          if (response.response.status == 404) {
            self.$parent.errortext = "register_wrongtan";
            return;
          }
          if (response.response.status == 412) {
            self.$parent.errortext = "register_already_exists";
            return;
          }

          self.$parent.errortext = "internalservererror";
        });
    },
    registerByCredential: function() {
      if (!this.canRegisterByCredential) {
        return;
      }
      this.$parent.errortext = null;
      var self = this;
      axios
        .post(
          this.GS.Endpoint + "/v2/registerbycredential/",
          this.form2JSON(document.getElementById("registerform")),
          {}
        )
        .then(function(response) {
            self.viewForm = false;
            if(response.status == 201)
            {
              self.showOKNoMail = true;
            }
            else
            {
              self.showOK = true;
            }
        })
        .catch(function(response) {
          window.scrollTo(0,0);
          //console.log(response);
          if (response.response == undefined) {
            self.$parent.errortext = "internalservererror";
            return;
          }
          if (response.response.status == 410) {
            self.$parent.errortext = "sessionexpired";
            return;
          }
          if (response.response.status == 403) {
            self.$parent.errortext = "loginblocked";
            return;
          }
          if (response.response.status == 401) {
            self.$parent.errortext = "loginfailed";
            return;
          }
          if (response.response.status == 404) {
            self.$parent.errortext = "register_credentials_wrong";
            return;
          }
          if (response.response.status == 412) {
            self.$parent.errortext = "register_already_exists";
            return;
          }
          if (response.response.status == 417) {
            self.$parent.errortext = "esprit_register_credentialexists";
            return;
          }
          self.$parent.errortext = "internalservererror";
        });
    },
    validateNumbers: function(evt) {
      var theEvent = evt || window.event;

      // Handle paste
      if (theEvent.type === 'paste') {
          key = event.clipboardData.getData('text/plain');
      } else {
      // Handle key press
          var key = theEvent.keyCode || theEvent.which;
          key = String.fromCharCode(key);
      }
      var regex = /[0-9]/;
      if( !regex.test(key) ) {
        theEvent.returnValue = false;
        if(theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 20px;
}
h2 {
  font-size: 15px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 20px;
}
h3 {
  color: #ca445f;
  font-size: 1.4em;
  font-weight: bold;
}
h4 {
  color: #ca445f;
  font-size: 1.2em;
  font-weight: normal;
  font-style: italic;
  margin-top: 20px;
  margin-bottom: 20px;
}
input {
  font-size: 13px;
}

p {
  margin-top: 5px;
  margin-bottom: 10px;
}

.disclaimer {
  font-size: 0.9em;
}

a {
  color: blue;
  font-weight: bold;
  text-decoration: none;
}
a:hover {
  color: blue;
  font-weight: bold;
  text-decoration: none;
}
</style>
